// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2s-BK","inputWrap":"Table_inputWrap__1lwDj","col":"Table_col__1sr6N","bmiTooltip":"Table_bmiTooltip__2ifNd"};